import { useNavigate } from "react-router-dom";
import { CheckCircle2, KeyRound, Mail, ArrowRight } from "lucide-react";

export default function PurchaseThanks() {
  const nav = useNavigate();

  return (
    <div className="min-h-screen bg-[#FFFDFC] flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-2xl rounded-[34px] bg-white border border-[#E8DDD8] shadow-[0_24px_80px_rgba(104,47,62,.10)] p-7 md:p-10 text-center">
        <div className="w-16 h-16 rounded-full bg-[#EBF2EE] text-[#4F7A61] mx-auto flex items-center justify-center">
          <CheckCircle2 size={34} />
        </div>
        <h1 className="font-display text-3xl md:text-5xl font-extrabold mt-5">Compra concluída.</h1>
        <p className="text-lg text-[#6F696D] mt-4 leading-relaxed">
          Agora falta somente ativar sua conta no NailControl com o código individual enviado após a confirmação do pagamento.
        </p>

        <div className="grid sm:grid-cols-2 gap-3 mt-7 text-left">
          <div className="rounded-2xl bg-[#F7F1ED] p-4">
            <Mail size={20} className="text-[#682F3E]" />
            <div className="font-bold mt-2">1. Confira sua entrega</div>
            <div className="text-sm text-[#71717A] mt-1">Você receberá as instruções e seu código de acesso pelo canal informado na compra.</div>
          </div>
          <div className="rounded-2xl bg-[#F7F1ED] p-4">
            <KeyRound size={20} className="text-[#682F3E]" />
            <div className="font-bold mt-2">2. Ative sua conta</div>
            <div className="text-sm text-[#71717A] mt-1">Use o código uma única vez para criar seu acesso individual.</div>
          </div>
        </div>

        <button onClick={() => nav("/register")}
          className="mt-7 inline-flex items-center justify-center gap-2 rounded-2xl bg-[#682F3E] text-white font-extrabold px-7 py-4 hover:bg-[#542431] transition">
          JÁ TENHO MEU CÓDIGO <ArrowRight size={18} />
        </button>

        <div className="mt-4">
          <button onClick={() => nav("/login")} className="text-sm text-[#817A7D] underline underline-offset-4">
            Já tenho conta e quero entrar
          </button>
        </div>
      </div>
    </div>
  );
}
